
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 45 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.131 3.991c.471-.41.91-.775 1.34-1.114 5.01-3.94 11.928-2.715 15.862 1.746 3.666 4.157 4.044 8.952 1.694 14.365-1.709 3.937-4.352 7.295-8.493 11.273-2.307 2.217-6.04 5.194-11.217 8.953l-.894.648-.885-.66c-2.913-2.173-5.081-3.823-6.507-4.954-4.762-3.774-8.277-7.323-10.97-11.352-2.42-3.621-3.65-7.125-3.556-10.881C.675 5.195 7.29-.255 14.302.609c2.33.287 4.175 1.316 6.547 3.289.353.293.73.595 1.194.957l.602.466c.549-.495 1.189-1.07 1.486-1.33zm8.324 24.107c3.88-3.728 6.3-6.8 7.82-10.304 1.918-4.418 1.637-7.978-1.192-11.186-2.948-3.343-8.093-4.255-11.757-1.373-.389.306-.79.64-1.225 1.02-.504.438-2.13 1.914-2.394 2.146l-.936.823-.98-.769c-.294-.23-1.379-1.068-1.593-1.234-.487-.38-.887-.7-1.268-1.017-1.968-1.637-3.367-2.417-4.995-2.617C8.652 2.935 3.63 7.073 3.504 12.09c-.077 3.07.95 5.994 3.051 9.14 2.496 3.733 5.802 7.07 10.34 10.667 1.25.992 3.102 2.406 5.551 4.239 4.612-3.378 7.953-6.063 10.01-8.038h-.001z"}})])
          )
        }
      }
    